@if (loadPage) {
	<main class="legal-request-container">
		<div class="wrapper-btn-create">
			<div></div>
			<div class="flex">
				@if (!configuration?.notHasPhase) {
					<button type="button" class="btn-primary btn-type-1" (click)="openModalPhase()">
						Nova fase
					</button>
				}
				@if (configuration?.notHasPhase && !configuration?.readOnly) {
					<button type="button" class="btn-primary btn-type-1" (click)="openRegisterModal()">
						Cadastrar pedido
					</button>
				}
			</div>
		</div>
		@if (configuration.notHasPhase) {
			<!-- <div
      class="flex flex-row flex-wrap w-full pt-[20px] pl-[20px] pr-[20px] mb-[40px] rounded-lg shadow-inner relative"
      [class.transitionEntrada]="transition=='entrada'"
      [class.motion-unfill-right]="transition=='saida'"
      [style.animation-delay.ms]="60"
      > -->
			<div class="wrapper-content">
				<div class="title">Pedidos</div>
				<div class="wrapper-general-info">
					@for (item of generalDataNoPhase; track item) {
						<div class="justify-start flex flex-col mt-[20px] mb-[20px]">
							<lbca-input-text
								[labeled]="false"
								[componetHelperIconLeftStyle]="item.icon + 'light-white'"
								[copyContent]="false"
								[label]="item.label"
								[value]="item.value"
								[maskInput]="item.mask"
							></lbca-input-text>
						</div>
					}
				</div>
				<div class="content open">
					@if (!(tableLegalRequest?.body?.length && tableLegalRequest?.loaded)) {
						<lbca-body-feedback feedbackIcon="noLegalrequests" type="claim">
							<ng-container claimMessagePrimary class="font-size: 20rem;">
								Nenhum pedido cadastrado
							</ng-container>
						</lbca-body-feedback>
					}
					@if (tableLegalRequest?.body?.length && tableLegalRequest?.loaded) {
						<lbca-table-secondary
							[table]="tableLegalRequest"
							[cardData]="cardInfo"
							[saveOnChange]="true"
							[removeLine]="lineremove"
							[rightDeslocation]="line"
							formType="form-primary"
						></lbca-table-secondary>
					}
				</div>
			</div>
		}
	</main>
}

<ng-template #actionsExcluirRender let-legalRequest>
	<div class="w-full flex items-center flex-row overflow-hidden justify-center">
		<label class="item-action-render" (click)="deleteItem($event, legalRequest)">
			@if (!legalRequest.remove) {
				<lbca-icon
					name="lucide:trash"
					class="icon-box hover:text-primary cursor-pointer"
				></lbca-icon>
			}
			@if (legalRequest.remove) {
				<lbca-icon
					name="lucide:circle-x"
					class="icon-box hover:text-primary cursor-pointer"
				></lbca-icon>
			}
		</label>
	</div>
</ng-template>

<ng-template #actionsEditRender let-legalRequest>
	<div class="w-full flex items-center flex-row overflow-hidden justify-center">
		<label class="item-action-render" (click)="editItem($event, legalRequest)">
			<lbca-icon
				name="lucide:pencil"
				class="icon-box hover:text-primary cursor-pointer"
			></lbca-icon>
		</label>
	</div>
</ng-template>

<ng-template #ModalEdit>
	@if (configuration?.notHasPhase) {
		<lbca-legalboxplus-legal-request-form
			[taskId]="taskId"
			[userId]="'user-id' | getItemLocalStorage"
			[processId]="processId"
			[cardData]="cardInfo"
			(closeModalOutput)="closeModal()"
			[initialValues]="legalRequestEdit"
			[simple]="simple"
			[payFields]="configuration?.payFields"
		/>
	}
</ng-template>

<ng-template #ModalRegisterTemplate>
	@if (configuration?.notHasPhase) {
		<lbca-legalboxplus-legal-request-form
			[taskId]="taskId"
			[userId]="'user-id' | getItemLocalStorage"
			[processId]="processId"
			[cardData]="cardInfo"
			(closeModalOutput)="closeModal()"
			[simple]="simple"
			[payFields]="configuration?.payFields"
		/>
	}
</ng-template>
